import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './conversations.css';
import { API_BASE_URL } from "../config";

const Conversations = () => {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/admin/conversations`);
        setConversations(res.data || []);
      } catch (err) {
        console.error('Failed to fetch conversations:', err);
      }
    };

    fetchConversations();
  }, []);

  const filteredConvos = conversations.filter(convo => {
    const name = convo?.name || "";
    const email = convo?.email || "";
    const status = convo?.status || "";

    const matchSearch =
      name.toLowerCase().includes(search.toLowerCase()) ||
      email.toLowerCase().includes(search.toLowerCase());

    const matchFilter = filter === 'all' || status === filter;
    return matchSearch && matchFilter;
  });

  return (
    <div className="convo-page">
      <h1 className="admin-heading">💬 Conversation Logs</h1>
      <div className="convo-filters">
        <input
          type="text"
          placeholder="Search by user or email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="all">All</option>
          <option value="success">Success</option>
          <option value="unresolved">Unresolved</option>
        </select>
      </div>
      <div className="convo-list">
        {filteredConvos.length > 0 ? (
          filteredConvos.map((convo, index) => (
            <div key={index} className="convo-card">
              <div className="convo-header">
                <strong>{convo?.name || "Unknown"}</strong> ({convo?.email || "N/A"}) –{" "}
                {convo?.latest
                  ? new Date(convo.latest).toLocaleDateString()
                  : "No date"}
                <span className={`status ${convo?.status || "unknown"}`}>
                  {convo?.status || "unknown"}
                </span>
              </div>
              <div className="convo-messages">
                {convo?.messages?.length > 0 ? (
                  convo.messages.map((msg, idx) => (
                    <p key={idx} className={`msg ${msg?.sender || "user"}`}>
                      <strong>
                        {msg?.sender === 'bot' ? 'AI' : 'User'}:
                      </strong>{" "}
                      {msg?.text || ""}
                    </p>
                  ))
                ) : (
                  <p>No messages</p>
                )}
              </div>
              <div className="convo-actions">
                <button>Mark as Flagged</button>
                <button>Send to Training</button>
                <button onClick={() => exportConvoAsText(convo)}>Export</button>
              </div>
            </div>
          ))
        ) : (
          <p>No conversations found.</p>
        )}
      </div>
    </div>
  );
};

// Utility: Export conversation as plain text
const exportConvoAsText = (convo) => {
  const content = convo?.messages
    ?.map((msg) => `${msg?.sender === 'bot' ? 'AI' : 'User'}: ${msg?.text || ""}`)
    .join('\n') || "No messages available.";

  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${convo?.name || "conversation"}_chat_${convo?.chat_id || "unknown"}.txt`;
  a.click();
};

export default Conversations;
